var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeoplePurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.275 7.79772C11.7877 6.65117 12.3831 4.70056 11.7575 2.94082C11.132 1.18109 9.42326 0 7.503 0C5.58274 0 3.87405 1.18109 3.24848 2.94082C2.62292 4.70056 3.21832 6.65117 4.731 7.79772C1.87865 8.89778 0.00488734 11.5705 0 14.5461V15.273C0 15.6745 0.335786 16 0.75 16H14.25C14.6642 16 15 15.6745 15 15.273V14.5461C14.9961 11.572 13.125 8.89963 10.275 7.79772ZM4.50005 4.36878C4.50005 2.76282 5.84319 1.46094 7.50005 1.46094C9.1569 1.46094 10.5 2.76282 10.5 4.36878C10.5 5.97473 9.1569 7.27661 7.50005 7.27661C5.84319 7.27661 4.50005 5.97473 4.50005 4.36878ZM7.49986 8.73047C4.18615 8.73047 1.49986 11.3342 1.49986 14.5461H13.4999C13.4999 11.3342 10.8136 8.73047 7.49986 8.73047Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeoplePurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/peoplePurple.1c6d8fe83301d2514067e36a8f9dd6b1.svg";